module.exports = __webpack_public_path__ + "static/img/地图@2x.bc41479.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/地图@2x.png
// module id = 3Mni
// module chunks = 1